<template>
    <el-dialog
        title="Day time distribution"
        :visible.sync="$store.state.project.view.count"
        width="40%"
        >
         <el-tabs v-model="activeName">
            <el-tab-pane label="Config" name="config">
                <div id="distrContainer">
            <div class="tip">
                Total amount has to be equal 100. Everything you leave unattended will be moved to "whole day" section.
            </div>
            <div v-if="$store.state.project.view.model.goal == 0" class="tip redTip">
                You don't have any tasks set for the bot, change that by setting a goal.
            </div>
            <el-row id="totalCount">
                {{total}}
            </el-row>
            <el-row class="centered">
                <el-col class="sectionName" :span="6">
                    Whole day:
                </el-col>
                <el-col :span="18">
                    <el-slider
                        v-model="$store.state.project.view.model.distributions.any"
                        show-input>
                    </el-slider>
                </el-col>
                <el-col class="sectionName" :span="6">
                    Morning:
                </el-col>
                <el-col :span="18">
                    <el-slider
                        v-model="$store.state.project.view.model.distributions.morning"
                        show-input>
                    </el-slider>
                </el-col>
                <el-col class="sectionName" :span="6">
                    Day:
                </el-col>
                <el-col :span="18">
                    <el-slider
                        v-model="$store.state.project.view.model.distributions.day"
                        show-input>
                    </el-slider>
                </el-col>
                <el-col  class="sectionName" :span="6">
                    Evening:
                </el-col>
                <el-col :span="18">
                    <el-slider
                        v-model="$store.state.project.view.model.distributions.evening"
                        show-input>
                    </el-slider>
                </el-col>
                <el-col class="sectionName" :span="6">
                    Night:
                </el-col>
                <el-col :span="18">
                    <el-slider
                        v-model="$store.state.project.view.model.distributions.night"
                        show-input>
                    </el-slider>
                </el-col>
            </el-row>
            <el-row id="error-row" v-if="this.error.type>0">
                <el-col :span="2">
                    <i class="el-icon-warning"></i>
                </el-col>
                <el-col :span="18">
                   <div id="errorsM">{{error.message}}</div>
                </el-col>
                <el-col :span="4">
                    <el-button v-if="error.type==1" v-on:click="moveToAny" type="danger">Move</el-button>
                </el-col>
                
            </el-row>
            <el-row class="centered marg">
                <el-button v-on:click="savePlaybook" type="danger">Save changes</el-button>
            </el-row>

        </div>
            </el-tab-pane>
            <el-tab-pane label="History" name="history">
                <el-row class="centered marg">
                    <el-tag
                        v-for="item in getHistory()"
                        :key="item.id"
                        :type="info">
                        {{item.goal}}
                    </el-tag>
                </el-row>
            </el-tab-pane>    
        </el-tabs>        
    </el-dialog>
</template>

<script>

export default {
    name: 'ScheduledCount',
    components: {
        
    },
    props: {
    },
    data () {
        return {
            error: {
                type: 0,
                message: '',
                data: 0
            },
            activeName: 'config'
        }
    },
    mounted: function () {
        var that = this;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'project/DISTRIBUTION_SET') {
                //so there is payload with id
                //mutation.payload.id
                var state = that.$store.state.project.view;
                state.count = false;
                that.$store.dispatch('project/setProjectView', state);
                this.writeHistory(
                    mutation.payload.id, 
                    mutation.payload.goal
                );
            }
        })
    },
    computed: {
        total () {
            var model = this.$store.state.project.view.model.distributions;
            if (typeof(model) == 'undefined') return 0;
            return (model.morning + model.day + model.evening + model.night + model.any);
        }
    },
    methods: {
        getModel() {
            //return this.$store.state.project.playbooks.data.filter(playbook => playbook.bot_id == this.info.id);
        },
        moveToAny() {
            var model = this.$store.state.project.view.model.distributions;
            var delta = 100 - (model.morning + model.day + model.evening + model.night + model.any);
            if (delta > 0) {
                this.$store.state.project.view.model.distributions.any += delta;
            }
        },
        validate() {
            var model = this.$store.state.project.view.model.distributions;
            var delta = 100 - (model.morning + model.day + model.evening + model.night + model.any);
            this.error = {
                type:0, message:''
            }

            if (delta > 0) {
                this.error.type = 1
                this.error.message = 'You have undistributed percents - ' + delta + '. You can cancel and fix it manually or let me move it all to "any"'
                this.error.data = delta
            }

            if (delta < 0) {
                this.error.type = 2
                this.error.message = 'You have planned way more than you are able to - ' + this.total + '. Total amount has to be equal to 100';
            }

            return this.error.type;
        },
        savePlaybook() {
            if (this.validate() !== 0) {
                return 1;   
            }

            this.writeHistory(
                this.$store.state.project.view.model.id, 
                this.$store.state.project.view.model.goal, 
            );
            
            //var data = JSON.parse(JSON.stringify(this.$store.state.project.view.model));
            //this.$store.dispatch('bot/updateBot', {model: data});
            var model = this.$store.state.project.view.model.distributions;
            var entity = {
                project_id: this.$store.state.project.view.model.project_id,
                bot_id: this.$store.state.project.view.model.id,
                any: model.any,
                morning: model.morning,
                day: model.day,
                evening: model.evening,
                night: model.night
            }
            this.$store.dispatch('project/setDistributionAction', entity);
        },
        getHistory() {
            var playbookHistory = JSON.parse(localStorage.getItem('lpt_plb_history_'+this.$store.state.project.view.model.id));
            if (playbookHistory === null) playbookHistory = [];
            return playbookHistory.reverse();
        },
        writeHistory(id, goal) {
            var playbookHistory = JSON.parse(localStorage.getItem('lpt_plb_history_'+id));
            if (playbookHistory === null) {
                playbookHistory = [];
            } else {
                if (playbookHistory.length >= 10) {
                    //cut the old data
                    playbookHistory = playbookHistory.slice(Math.max(playbookHistory.length - 9, 1));
                }
            } 

            playbookHistory.push({
                    goal: goal,
                    date: new Date()
            });

            localStorage.setItem('lpt_plb_history_'+id, JSON.stringify(playbookHistory));
        },
        deletePlaybook() {
            var that = this;
            this.$confirm('This will permanently delete the playbook. Continue?', 'Warning', 
            {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                that.$store.dispatch('project/deletePlaybook', {
                    project_id: this.$route.params.id, 
                    playbook_id: this.$store.state.project.view.model.playbook_id,
                });
                var state = that.$store.state.project.view;
                state.count = false;
                that.$store.dispatch('project/setProjectView', state);
            }).catch(() => {
            this.$message({
                type: 'info',
                message: 'Delete canceled'
            });          
            });
        },
        newPlaybook() {
            this.$store.dispatch('project/createPlaybook', this.$store.state.project.view.model);
        },
    }
}
</script>

<style lang="scss" scoped>
    .centered {
        text-align: center;
    }
    
    .marg {
        margin-top:20px;
    }
    #distrContainer {
        padding:25px;
    }
    #error-row {
        margin-top:10px;
        color: grey;
        word-wrap: normal !important;
         white-space: normal;
    }
    #totalCount {
        text-align: center;
        font-size: 32px;
        font-weight: 900;
    }
    #errorsM {
        word-break: normal;
        padding-right:10px;
    }
    .sectionName{
        padding-top:10px;
        text-align: left;
    }
    .redTip {
        background-color: #ffa150;
    }
</style>
